// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:27:32.378Z
// Property: Westwood Terrace (ID: 5764347288616960)
// Collections: 16 amenities, 4 floorplans (live), 18 photos, 82 POIs, 3 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5764347288616960",
  "property_external_id": "4981190",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/westwood-apartment-homes/5XrRFV/",
  "property_apartments_url": "https://www.apartments.com/westwood-terrace-san-antonio-tx/yclskcs",
  "property_google_business_url": "https://www.google.com/maps/place/Westwood+Apartments/@29.4983818,-98.7140037,17z/data=!4m13!1m7!3m6!1s0x865c427972d64631:0xa9822bc874de3ab0!2s11139+Culebra+Rd,+San+Antonio,+TX+78253!3b1!8m2!3d29.4983818!4d-98.711815!3m4!1s0x865c43318d918e69:0x3f5fc528bbf5f142!8m2!3d29.4985245!4d-98.7117637",
  "property_linkedin_url": null,
  "property_hubspot_id": "8775177759",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "westwood-terrace",
  "property_name": "Westwood Terrace",
  "property_website_url": "https://www.westwoodterraceliving.com/",
  "property_domain": "https://www.westwoodterraceliving.com/",
  "property_address": "11139 Culebra Rd",
  "property_full_address": "11139 Culebra Rd, San Antonio, TX 78253",
  "property_address_1": "11139 Culebra Rd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78253-6421",
  "property_address_zip": "78253",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Far West Side",
  "property_address_latitude": "29.4991321",
  "property_address_longitude": "-98.7119869",
  "property_email": "westwood@alapts.com",
  "property_phone": "(210) 688-9444",
  "property_call_tracking_phone": "361-309-1390",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Far West Side living starts here.</strong> Explore one- and two-bedroom apartments with granite countertops, stainless steel appliances, hardwood-style flooring, and everyday convenience near Culebra Road and Loop 1604—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Westwood Terrace in person.</p>",
  "property_long_description": "<p><strong>Modern Far West Side living with everyday convenience close by.</strong> At Westwood Terrace, you can choose a one- or two-bedroom apartment with polished finishes like granite countertops with undermount sinks, designer cabinetry, stainless steel appliances, decorative tile backsplashes, hardwood-style flooring, built-in desks, USB outlets, and available in-home laundry or washer/dryer connections.</p><p>Step outside for a <a href=\"/amenities\">pool, fitness center, clubhouse, controlled access, EV charging stations, and online resident services</a>, all in a pet-friendly community designed for easy coming and going. Around Culebra Road and Loop 1604, you’re close to Westwood Center, H-E-B, Target, Walmart, Home Depot, Lowe’s, and the growing Alamo Ranch retail corridor.</p><p>When you want more room to roam, <a href=\"/neighborhood\">the Far West Side</a> puts Government Canyon State Natural Area, SeaWorld San Antonio, the San Antonio Aquarium, and Northwest Vista College within reach—giving you a home base with modern comfort, practical access, and plenty to explore.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019d02f5-2509-749f-990d-fe7a094ba728.webp",
  "property_featured_image_media": {
    "alt_text": "Dining area and kitchen with island in apartment",
    "public_id": "019d02f5-2509-749f-990d-fe7a094ba728",
    "storage_key": "property/5764347288616960/019d02f5-2509-749f-990d-fe7a094ba728.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "204",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.13725490196079",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Admin Fee $100\nApp Fee $50\nPet Fee $350\nPet Deposit $200",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 for your 1st pet and an additional $200 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 for your 1st pet and an additional $200 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8879184.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://westwoodterrace.loftliving.com/login",
  "property_apply_now_url": "https://8879184.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a1f-14aa-7249-bd30-3f5800f34114.webp",
  "property_primary_logo_media": {
    "alt_text": "Westwood Terrace Premier Apartments logo with a light blue floral graphic.",
    "public_id": "019e8a1f-14aa-7249-bd30-3f5800f34114",
    "storage_key": "property/5764347288616960/019e8a1f-14aa-7249-bd30-3f5800f34114.webp",
    "width": 1673,
    "height": 582
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019d02f5-170f-76dc-b56e-e24725580937.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f5-170f-76dc-b56e-e24725580937",
    "storage_key": "property/5764347288616960/019d02f5-170f-76dc-b56e-e24725580937.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a1f-14aa-7249-bd30-3f5800f34114.webp",
  "property_icon_media": {
    "alt_text": "Westwood Terrace Premier Apartments logo with a light blue floral graphic.",
    "public_id": "019e8a1f-14aa-7249-bd30-3f5800f34114",
    "storage_key": "property/5764347288616960/019e8a1f-14aa-7249-bd30-3f5800f34114.webp",
    "width": 1673,
    "height": 582
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a1f-145e-71cc-a6aa-001f3a27820a.webp",
  "property_fav_icon_media": {
    "alt_text": "Stylized light blue flower logo on a black background",
    "public_id": "019e8a1f-145e-71cc-a6aa-001f3a27820a",
    "storage_key": "property/5764347288616960/019e8a1f-145e-71cc-a6aa-001f3a27820a.webp",
    "width": 947,
    "height": 947
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f8b65-5688-7638-a21d-c71aaf504725.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f8b65-5688-7638-a21d-c71aaf504725",
    "storage_key": "property/5764347288616960/019f8b65-5688-7638-a21d-c71aaf504725.webp",
    "width": 1280,
    "height": 445
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f8b65-4aad-7639-8f30-5234a80c0883.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f8b65-4aad-7639-8f30-5234a80c0883",
    "storage_key": "property/5764347288616960/019f8b65-4aad-7639-8f30-5234a80c0883.webp",
    "width": 1280,
    "height": 445
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#a79761",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#4b4d51",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "499 - 937",
  "property_sqft_min": "499",
  "property_sqft_max": "937",
  "property_price_range": "1021.33 - 1475",
  "property_price_min": "1021.33",
  "property_price_max": "1475",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/westwoodterraceapts",
  "property_instagram_url": "https://www.instagram.com/westwoodterrace",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJaY6RjTFDXIYRQvH1uyjFXz8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/westwood-apartment-homes-san-antonio",
  "property_tiktok_url": "https://www.tiktok.com/@westwood_terrace",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished comfort, everyday ease.</strong> Westwood Terrace pairs on-site EV charging, 24/7 online resident services, controlled access, a refreshing pool, clubhouse, and fitness center with stylish one- and two-bedroom interiors. Inside, enjoy granite countertops, stainless steel appliances, designer cabinetry, tile backsplashes, built-in desks, USB outlets, and hardwood-style flooring, with select homes offering in-home laundry, washer/dryer connections, patios, balconies, or pool views.</p>",
  "property_home_floorplans_blurb": "<p><strong>One- and two-bedroom layouts with polished everyday style.</strong> At Westwood Terrace, open living areas flow into kitchens finished with stainless steel appliances, built-in microwaves, granite countertops, tile backsplashes, and designer cabinetry. Select homes add built-in desks, walk-in closets, in-home laundry or washer/dryer connections, plus a patio or balcony for extra breathing room. Compare available floor plans and find the space that fits your routine.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Westwood Terrace.</strong> Preview bright kitchens with dark designer cabinetry, gleaming countertops, stainless steel appliances, and standout tile backsplashes. Then look closer at hardwood-style flooring, ceiling fans, and select patios or balconies made for fresh-air moments. Beyond the front door, the gallery captures sunny pool days, fitness center time, and clubhouse convenience on San Antonio’s Far West Side.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Culebra Road puts Far West Side favorites within easy reach.</strong> From Westwood Terrace, Alamo Ranch shopping, Longhorn Cafe, and BJ’s Restaurant &amp; Brewhouse are minutes away near Loop 1604, while Government Canyon State Natural Area offers a scenic trail reset in the other direction. Highway 151 and Loop 1604 keep Westover Hills, SeaWorld San Antonio, and the wider metro connected to your day.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the follow-through at Westwood Terrace.</strong><br>Reviews highlight responsive management, helpful communication, and maintenance that acts quickly—like an AC repair handled right away. Residents also call out the clean, well-maintained setting and welcoming atmosphere, with one review summing it up as “clean, well maintained, and welcoming.” Read more to see how everyday service and care shape the Westwood Terrace experience.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your Far West Side routine from a Culebra Road address.</strong> Westwood Terrace puts you close to the Alamo Ranch shopping corridor, where errands, patio meals, and casual favorites like Longhorn Cafe and BJ’s Restaurant &amp; Brewhouse cluster around Loop 1604. Head the other direction for Hill Country scenery at Government Canyon State Natural Area, with miles of trails for a reset beyond the city buzz. When plans take you farther, Highway 151 and Loop 1604 connect you with Westover Hills, SeaWorld San Antonio, and the wider San Antonio metro.</p><p>Back home, <a href=\"/amenities\">community amenities</a> like the pool, fitness center, controlled access, and EV charging make it easy to shift from out-and-about to settled in. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location works for your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At Westwood Terrace, practical conveniences and polished finishes work together from the moment you pull in. Charge your car on site, manage requests through 24/7 online resident services, and move through a controlled access community with shared spaces designed for downtime, from the pool and clubhouse to the fitness center.</p><p>Inside your one- or two-bedroom apartment in San Antonio, details feel thoughtfully chosen: granite countertops with undermount sinks, stainless steel appliances, designer cabinetry, decorative tile backsplashes, built-in desks, USB outlets, and hardwood-style flooring. Select homes add in-home laundry or washer/dryer connections plus a patio, balcony, or pool view. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the amenities come together.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Westwood Terrace.</strong> Choose a modern one- or two-bedroom apartment with polished finishes like granite countertops, stainless steel appliances, hardwood-style flooring, built-in desks, and available in-home laundry. With everyday conveniences close by and online resident services, it’s easy to take the next step toward your new home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Connect with the Westwood Terrace leasing team for details on one- and two-bedroom apartments, polished finishes, and everyday convenience near Culebra Road and Loop 1604. We’re here to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Westwood Terrace?</strong> Start here for quick answers on the community, leasing, apartment features, pet-friendly living, and everyday resident services. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Westwood Terrace offers one- and two-bedroom floor plans in San Antonio, from streamlined one-bedroom apartments that keep daily routines simple to roomier two-bedroom designs with the option of an extra bath. Inside, open living areas connect easily to kitchens with stainless steel appliances, built-in microwaves, granite countertops, decorative tile backsplashes, and designer cabinetry, creating a polished backdrop for cooking, relaxing, and staying organized.</p><p>Select homes add practical touches like built-in desks, walk-in closets, in-home laundry or washer/dryer connections, and a balcony or patio for a little outdoor breathing room. Browse current pricing and availability, compare your favorite layouts, then explore more <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the space in person.</p>",
  "property_gallery_blurb": "<p><strong>See Westwood Terrace in full color.</strong> Browse photos that bring the details into focus: bright kitchens with dark designer cabinetry, gleaming countertops, stainless steel appliances, and tile backsplashes made to stand out in every frame. Follow the gallery into living areas with hardwood-style flooring, ceiling fans, and easy indoor-outdoor flow to a patio or balcony in select homes.</p><p>Outside, picture relaxed afternoons by the pool, a workout in the fitness center, or a stop through the clubhouse before heading out on the Far West Side. Like what you see? Explore more <a href=\"/amenities\">features and finishes</a>, view <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Westwood Terrace in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Westwood Terrace on the map.</strong><br>Find available one- and two-bedroom apartments, then see what’s close around Culebra Road and Loop 1604—from everyday shopping to Far West Side destinations and outdoor escapes within reach.</p>",
  "property_pets_blurb": "<p><strong>Bring the paws along.</strong> Westwood Terrace makes pet-friendly apartment living feel simple, with cats and dogs welcome, up to two per home, and no weight limit. Inside, hardwood-style flooring, ceiling fans, and available patios or balconies help daily routines feel easy; outside, the controlled access community gives you a comfortable place to come and go for walks around the Far West Side. When it’s time for food, grooming, daycare, or vet care, nearby Culebra Road and Loop 1604 options keep the basics close without turning pet errands into a project. Explore <a href=\"/floor-plans\">one- and two-bedroom floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to picture how life with your cat or dog fits at Westwood Terrace.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Westwood Terrace?</strong> Share modern Far West Side living with a friend—from polished apartment finishes like granite countertops and stainless steel appliances to convenient resident services, pet-friendly spaces, and easy access off Culebra Road and Loop 1604. Send a referral and invite them to make Westwood Terrace home, too.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Westwood Terrace.</strong><br>Make everyday living easier with online resident services built for quick account management. Log in to pay rent, submit maintenance requests, and stay connected to your home—all with the same practical convenience that defines life on Culebra Road.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Westwood Terrace.</strong><br>Reviews point to the everyday details that make a difference: responsive management, maintenance that follows through, and a community that feels comfortable when you come home. Residents mention quick attention to work orders—including an AC repair handled immediately—as well as a clean, well-maintained setting and a welcoming atmosphere. One reviewer summed it up as “clean, well maintained, and welcoming,” while another praised the team for doing their best to help when questions come up. As you read the reviews below, you’ll get a firsthand look at how service, communication, and care shape the Westwood Terrace experience.</p>",
  "property_created_at": "1752256741062",
  "property_scheduletour_blurb": "<p><strong>See modern Far West Side living up close.</strong><br>Tour Westwood Terrace and picture polished finishes like granite countertops, stainless steel appliances, hardwood-style flooring, built-in desks, and convenient laundry options—all with easy access to everyday shopping and dining. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br> The Westwood Terrace leasing team will follow up soon. In the meantime, picture modern Far West Side living with polished apartment finishes, convenient everyday access, and a pet-friendly community designed for easy coming and going.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Westwood Terrace from wherever you are with virtual tours that put the spaces in motion: take a community walkthrough, look around the clubhouse, preview the one-bedroom apartment tour, and see the fitness center up close. As you move through each view, notice the details that photos can only suggest—open living flow, sleek kitchen finishes, comfortable lounge areas, and a bright workout space designed for everyday convenience.</p><p>Use the tours to compare what matters most, then keep browsing the <a href=\"/gallery\">photo gallery</a>, review current <a href=\"/floor-plans\">floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to experience Westwood Terrace in San Antonio in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Westwood Terrace",
  "property_seo_title_home": "Westwood Terrace | Apartments in San Antonio, TX",
  "property_seo_description_home": "Unveil your ideal living space at Westwood Terrace in vibrant San Antonio, TX. Choose from thoughtfully designed one and two-bedroom floor plans, each equipped with modern amenities like smart locks, built-in desks, and energy-efficient car charging stations. Enjoy a lifestyle redefined with access gates, a state-of-the-art fitness center, and a refreshing pool. Plus, with convenient online resident services and a welcoming clubhouse, your comfort is our priority. Make Westwood Terrace your new home today and elevate your living experience!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in San Antonio, TX",
  "property_seo_description_floorplans": "Uncover the ideal blend of comfort and style at Westwood Terrace in San Antonio, TX. With thoughtfully designed one and two-bedroom floor plans, each space is crafted to meet your lifestyle needs. Browse our diverse selection of apartment homes to find the perfect fit for you—where modern living meets serene surroundings. Your next chapter starts here!",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Welcome to Westwood Terrace in San Antonio, TX—where modern living meets convenience. Dive into a lifestyle enhanced by access gates, smart locks, and fitness centers. Whether you prefer the spacious one or two-bedroom floor plans, enjoy built-in desks, USB outlets, and stylish tile backsplashes. Unwind by the pool or connect with neighbors in our resident clubhouse. Experience comfort and community like never before. Check out our exceptional amenities today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "Step into a visual journey at Westwood Terrace in San Antonio, TX. Our photo gallery showcases vibrant amenities like a sparkling pool, state-of-the-art fitness center, and stylish units featuring built-in desks and modern appliances. Revel in the luxury of smart locks, car charging stations, and convenient online resident services. With one- and two-bedroom floor plans designed for comfort, your future home awaits! Picture yourself living in your dream space today!",
  "property_seo_title_virtualtours": "Virtual Tours | Westwood Terrace Apartments",
  "property_seo_description_virtualtours": "Step inside Westwood Terrace, your future home in vibrant San Antonio, TX! Immerse yourself in our stunning one and two-bedroom floor plans, designed for comfort and style. Whether you’re looking for a cozy retreat or a spacious haven, we have the perfect space for you. Ready to envision your new lifestyle? Take a virtual tour of our community and apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Westwood Terrace Apartments",
  "property_seo_description_interactivemap": "Unlock your ideal living experience at Westwood Terrace in San Antonio, TX. With stylish one and two-bedroom floor plans featuring modern amenities like smart locks, USB outlets, and a built-in desk, your comfort is our priority. Enjoy community highlights such as a fitness center, sparkling pool, and welcoming resident clubhouse. Use our interactive community map to explore availability and pricing, and find your perfect home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Experience the vibrant charm of San Antonio from Westwood Terrace, where our one and two-bedroom apartments place you in the heart of a thriving neighborhood. Immerse yourself in local favorites, unique eateries, and inviting parks just steps from your door. Dive into the community's rich culture and uncover hidden gems that make this area truly special. Your ideal lifestyle awaits—see what surrounds Westwood Terrace today!",
  "property_seo_title_contact": "Contact Us | Westwood Terrace",
  "property_seo_description_contact": "Elevate your lifestyle at Westwood Terrace in sunny San Antonio, TX. Our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and convenience. Ready to learn more? Reach out to our friendly leasing team for any inquiries today!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Unlock the secrets of Westwood Terrace in San Antonio, TX, where elegance meets convenience. Our FAQs page answers all your burning questions about our stylish one and two-bedroom floor plans, top-tier amenities like a fitness center, resident clubhouse, and smart locks. From car charging stations to dedicated online resident services, find out how we redefine apartment living. Browse our FAQs now and take the first step toward your new home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Experience the charm of Westwood Terrace in San Antonio, TX, where vibrant living meets modern convenience. Our residents enjoy spacious one- and two-bedroom floor plans, state-of-the-art amenities like smart locks, car charging stations, and a fully-equipped fitness center. Get inspired by the community spirit in our resident clubhouse or unwind by the pool. Don't just take our word for it—see what our residents are saying about their life here!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Unlock the door to modern living at Westwood Terrace in vibrant San Antonio, TX. Our thoughtfully designed one- and two-bedroom floor plans feature upscale amenities like a state-of-the-art fitness center, refreshing pool, and stylish resident clubhouse. Enjoy the convenience of access gates, smart locks, and USB outlets in every home. With online resident services and car charging stations, we cater to your lifestyle. Ready to elevate your living experience? Find your new sanctuary and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Westwood Terrace",
  "property_seo_description_residentaccess": "\"Welcome to Westwood Terrace in vibrant San Antonio, TX. Unlock the door to effortless living—log in to your resident portal to manage rent payments, request maintenance, and enjoy seamless community updates. Your convenience starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Westwood Terrace",
  "property_seo_description_referafriend": "\"Share the joy of living at Westwood Terrace in San Antonio! Refer a friend today and enjoy vibrant community perks together. Great friends make great neighbors—let’s grow this welcoming oasis!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Westwood Terrace",
  "property_seo_description_scheduletour": "Experience the charm of Westwood Terrace in San Antonio, TX! Immerse yourself in our vibrant community, featuring beautiful apartments and exceptional amenities. Schedule a tour today and step into your dream home!",
  "property_seo_title_privacy": "Privacy Policy | Westwood Terrace",
  "property_seo_description_privacy": "\"At Westwood Terrace in vibrant San Antonio, your privacy is our priority. Dive into our comprehensive privacy policy to understand how we safeguard your personal information while you enjoy the comfort of our community. Your peace of mind starts here!\"",
  "property_seo_title_accessibility": "Website Accessibility | Westwood Terrace",
  "property_seo_description_accessibility": "\"At Westwood Terrace in San Antonio, TX, we believe everyone deserves a welcoming home. Our Accessibility Statement highlights our commitment to digital inclusion, ensuring a seamless experience for all residents and visitors. Join a community where accessibility meets comfort!\"",
  "property_seo_title_sitemap": "Sitemap | Westwood Terrace",
  "property_seo_description_sitemap": "Uncover the blueprint of your future home at Westwood Terrace in vibrant San Antonio, TX. Navigate through our comprehensive sitemap to find your perfect apartment and experience a community where comfort meets style. Your ideal living space awaits—take the first step today!",
  "property_seo_title_thankyou": "Thank You | Westwood Terrace",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Westwood Terrace in vibrant San Antonio, TX, means a lot to us. Get ready to experience a community where modern comfort meets southern charm. A team member will connect with you shortly to discuss your next steps toward making Westwood Terrace your new home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320987",
  "amenities": [
    {
      "id": "custom_55be873f-6826-40b3-8e41-dbce55dbbfe4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops w/Undermount Sinks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6c68ece-7207-4978-8e1f-61165b07063e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Washer & Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffaaa64b-9fb1-4f53-94eb-c3ad50303969",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000605",
      "title": "Built-In Desk",
      "amount": "0.0000",
      "description": "Built-In Desks",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14f78eed-0385-45e8-a914-1aa44511cb08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaadc5c4-78b6-434d-b5e1-6d6c21ee5632",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f376768-26db-447b-a067-c9ab346ab60b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b293281-598b-42fa-bab4-6ef78c56e409",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b25d8b62-ee66-4dbb-8780-ddce59a35e13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdc7acce-c9f9-435b-85b5-cfa7119d780c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort Style Pool w/Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8087f768-5375-4e9e-8f2a-f94eb362016e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c651290-cf70-4333-bfb2-9fc512976a24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_daa81aad-11ba-4775-9e8f-910de0921003",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Vehicle Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ba72069-95f1-4bdb-9d96-f18388e6456a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a377753e-a245-4b0c-a8f5-a44ec54ca83f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1d8c55d-a8ad-4052-babf-f84f226c35f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60e7926d-0824-4d56-8c0e-d12be6d99e5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_782384f0-61de-4e1f-a37a-80f860e57c7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, perfect for relaxing and unwinding under the sun. Ample lounge seating and shaded cabanas available.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a33dbfb2-4688-4f0f-8fcd-6c0fa2f0c547",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-5cc5-744d-a747-b40e6c8c9afb.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, sofa, ottoman, and coffee table.",
        "public_id": "019e8a0d-5cc5-744d-a747-b40e6c8c9afb",
        "storage_key": "property/5764347288616960/019e8a0d-5cc5-744d-a747-b40e6c8c9afb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant living room featuring a modern fireplace, a mounted television, comfortable seating, and stylish decor. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, TV, sofa, ottoman, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47131b39-c99b-41c8-8144-28d0cbfd5b8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-57a2-7762-8f16-2a8a05b4035d.webp",
      "image_media": {
        "alt_text": "Exterior double doors with blinds, a small balcony, and lush greenery.",
        "public_id": "019e8a0d-57a2-7762-8f16-2a8a05b4035d",
        "storage_key": "property/5764347288616960/019e8a0d-57a2-7762-8f16-2a8a05b4035d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Step out onto your private balcony through elegant double doors, surrounded by vibrant landscaping. Enjoy the fresh air and serene views from your apartment's outdoor space.",
      "link": "",
      "alt_text": "Exterior double doors with blinds, a small balcony, and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57747f42-f07f-4dee-b4bd-2e58e01286c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-5867-729e-a30b-057fb14e84a6.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
        "public_id": "019e8a0d-5867-729e-a30b-057fb14e84a6",
        "storage_key": "property/5764347288616960/019e8a0d-5867-729e-a30b-057fb14e84a6.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful outdoor pool, a perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7b7a3ec-74aa-45c7-91b3-4596ade017a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-5dd2-7666-8ab4-a07574ad5ad6.webp",
      "image_media": {
        "alt_text": "Dining area with oval table and chairs next to a kitchen with stainless steel appliances.",
        "public_id": "019e8a0d-5dd2-7666-8ab4-a07574ad5ad6",
        "storage_key": "property/5764347288616960/019e8a0d-5dd2-7666-8ab4-a07574ad5ad6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals in the spacious dining area adjacent to a modern kitchen equipped with stainless steel appliances.",
      "link": "",
      "alt_text": "Dining area with oval table and chairs next to a kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23c4ba99-1abf-4664-a6cb-dd75d96b44c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-5264-74f6-8e8f-1ee4aef1aeda.webp",
      "image_media": {
        "alt_text": "Empty closet with shelving and two round ottomans.",
        "public_id": "019e8a0d-5264-74f6-8e8f-1ee4aef1aeda",
        "storage_key": "property/5764347288616960/019e8a0d-5264-74f6-8e8f-1ee4aef1aeda.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring built-in shelving and two decorative ottomans, perfect for storage and convenience.",
      "link": "",
      "alt_text": "Empty closet with shelving and two round ottomans.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b19a478f-200c-4059-a561-2fbb61c143da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-5050-7289-9e3f-11a77d32b9e2.webp",
      "image_media": {
        "alt_text": "Westwood Terrace cafe area with coffee station and office space visible",
        "public_id": "019e8a0d-5050-7289-9e3f-11a77d32b9e2",
        "storage_key": "property/5764347288616960/019e8a0d-5050-7289-9e3f-11a77d32b9e2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments in the Westwood Terrace cafe, with comfortable seating and access to business centers.",
      "link": "",
      "alt_text": "Westwood Terrace cafe area with coffee station and office space visible",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4e3d93fa-9fc7-4acc-83fb-be7a61c1bd18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-541c-757c-9dc3-aa0623d753ad.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
        "public_id": "019e8a0d-541c-757c-9dc3-aa0623d753ad",
        "storage_key": "property/5764347288616960/019e8a0d-541c-757c-9dc3-aa0623d753ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17e88b80-d2f9-47bf-ab40-9278fdeed16b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-40ce-72fc-9f8b-78b6516b4af0.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment and benches.",
        "public_id": "019e8a0d-40ce-72fc-9f8b-78b6516b4af0",
        "storage_key": "property/5764347288616960/019e8a0d-40ce-72fc-9f8b-78b6516b4af0.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our fenced dog park, complete with agility equipment and comfortable benches for you and your furry friend.",
      "link": "",
      "alt_text": "Fenced dog park with agility equipment and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85565ecf-1075-4d5d-9ecd-958f244e0866",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-42d4-77ce-9941-221952909ff5.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, weight racks, and punching bag.",
        "public_id": "019e8a0d-42d4-77ce-9941-221952909ff5",
        "storage_key": "property/5764347288616960/019e8a0d-42d4-77ce-9941-221952909ff5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio equipment, free weights, and a boxing station for a complete workout experience.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio machines, weight racks, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_37239a8b-0525-4351-939f-45cbc8338617",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-419d-7338-ae8e-5bdcef076ec8.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, rowing machine, punching bag, and mirrors.",
        "public_id": "019e8a0d-419d-7338-ae8e-5bdcef076ec8",
        "storage_key": "property/5764347288616960/019e8a0d-419d-7338-ae8e-5bdcef076ec8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and a boxing station for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, rowing machine, punching bag, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de2790a8-6948-4298-895f-ca4d0428b4b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-38f3-73aa-a108-7c36311b2ef4.webp",
      "image_media": {
        "alt_text": "A staged living room with a couch, two chairs, a coffee table, and a rug.",
        "public_id": "019e8a0d-38f3-73aa-a108-7c36311b2ef4",
        "storage_key": "property/5764347288616960/019e8a0d-38f3-73aa-a108-7c36311b2ef4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable couch, elegant accent chairs, and a modern coffee table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "A staged living room with a couch, two chairs, a coffee table, and a rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c071dff-12b9-4500-b765-d3d3aab82b63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-3764-76de-9f7e-eb2303d68ad9.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019e8a0d-3764-76de-9f7e-eb2303d68ad9",
        "storage_key": "property/5764347288616960/019e8a0d-3764-76de-9f7e-eb2303d68ad9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed apartment bathroom, featuring a sleek vanity, modern fixtures, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern apartment bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b204302-34d3-4b3d-97ac-313c1daf1e9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-31f0-713e-8682-b41b72154bcc.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "019e8a0d-31f0-713e-8682-b41b72154bcc",
        "storage_key": "property/5764347288616960/019e8a0d-31f0-713e-8682-b41b72154bcc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a queen-size bed with blue accents, a modern nightstand, and a dresser with decor.",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a869d621-63fa-4b49-aa83-e51b33f9e4d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-320d-71bb-a1d8-62e16b50f398.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and stove in a modern apartment kitchen with gray cabinets and granite countertops.",
        "public_id": "019e8a0d-320d-71bb-a1d8-62e16b50f398",
        "storage_key": "property/5764347288616960/019e8a0d-320d-71bb-a1d8-62e16b50f398.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience modern living in this apartment kitchen, featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and stove in a modern apartment kitchen with gray cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_638951e0-74b6-49b7-944c-2f36f88f64de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-2e04-7189-9dc0-80f4e92fde5e.webp",
      "image_media": {
        "alt_text": "Westwood Terrace Premier Apartments package lockers and bulletin board",
        "public_id": "019e8a0d-2e04-7189-9dc0-80f4e92fde5e",
        "storage_key": "property/5764347288616960/019e8a0d-2e04-7189-9dc0-80f4e92fde5e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers with the Westwood Terrace Premier Apartments logo and a community bulletin board are shown in a common area.",
      "link": "",
      "alt_text": "Westwood Terrace Premier Apartments package lockers and bulletin board",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1c47ca0-2b92-407d-b711-41d25c96e1dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-3602-73af-ad8b-8656fb5bee7c.webp",
      "image_media": {
        "alt_text": "Stylish living room with a white sofa, marble coffee table, and a large TV displaying a landscape.",
        "public_id": "019e8a0d-3602-73af-ad8b-8656fb5bee7c",
        "storage_key": "property/5764347288616960/019e8a0d-3602-73af-ad8b-8656fb5bee7c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience modern comfort in this beautifully appointed living room, featuring a plush sofa, elegant coffee table, and entertainment center.",
      "link": "",
      "alt_text": "Stylish living room with a white sofa, marble coffee table, and a large TV displaying a landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_560421a2-f5f4-4f53-9f70-0b27264634ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019e8a0d-2df8-7060-bbca-fd3a57c13e8f.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e8a0d-2df8-7060-bbca-fd3a57c13e8f",
        "storage_key": "property/5764347288616960/019e8a0d-2df8-7060-bbca-fd3a57c13e8f.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. A perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_83d8cfe65c822cdc19eb1705",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Colombia Tierra Querida",
      "poi_type": "Restaurants",
      "poi_address": "11019 Culebra Rd #122, San Antonio, TX 78254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-b058-70ae-8513-13d9295dab6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b058-70ae-8513-13d9295dab6d",
        "storage_key": "property/5764347288616960/019f14e9-b058-70ae-8513-13d9295dab6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://colombiatierraqueridatx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793060437061344473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colombia-tierra-querida",
      "poi_latitude": "29.4976894",
      "poi_longitude": "-98.7097861",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-677-2371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUGcFwBDXIYR2Rz55pTw54c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "ec_b7a9aba4426a9d107f4b5290",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Qargo Coffee",
      "poi_type": "Restaurants",
      "poi_address": "12015 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-b0c2-767c-8b8e-f7c5fdd9e661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b0c2-767c-8b8e-f7c5fdd9e661",
        "storage_key": "property/5764347288616960/019f14e9-b0c2-767c-8b8e-f7c5fdd9e661.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://qargocoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5102168238867642029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qargo-coffee",
      "poi_latitude": "29.5053395",
      "poi_longitude": "-98.7315272",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 726-230-5150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-5452-73de-8bb6-40577cf316a8",
        "storage_key": "property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMwnlrcBpXIYRrXb8FfuKzkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "ec_fc4182ad337f8b420e3451b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Black Rock Coffee Bar",
      "poi_type": "Restaurants",
      "poi_address": "12030 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_long_description": "Contemporary coffee chain serving classic, specialty & iced espresso beverages, plus smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-b694-704b-a260-e2ba2feaf1bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b694-704b-a260-e2ba2feaf1bc",
        "storage_key": "property/5764347288616960/019f14e9-b694-704b-a260-e2ba2feaf1bc.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.br.coffee/locations/culebra-alamo-pkwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=10280016185552052224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rock-coffee-bar",
      "poi_latitude": "29.5028865",
      "poi_longitude": "-98.7296824",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 833-843-5776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0ce1-7734-a7e5-d1654f1288eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0ce1-7734-a7e5-d1654f1288eb",
        "storage_key": "property/5764347288616960/019f14ea-0ce1-7734-a7e5-d1654f1288eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJNahR_61pXIYRAKAYQUH0qY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_938c374466821184d799497a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Maple Street Biscuit Company",
      "poi_type": "Restaurants",
      "poi_address": "10650 Culebra Rd #102, San Antonio, TX 78251, USA",
      "poi_short_description": "Casual cafe serving biscuit sandwiches & Southern sides for breakfast & lunch.",
      "poi_long_description": "Casual cafe serving biscuit sandwiches & Southern sides for breakfast & lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-a446-769c-a196-f60cdc803a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a446-769c-a196-f60cdc803a29",
        "storage_key": "property/5764347288616960/019f14e9-a446-769c-a196-f60cdc803a29.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.maplestreetbiscuits.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=16104477266775621831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maple-street-biscuit-company",
      "poi_latitude": "29.4925617",
      "poi_longitude": "-98.7022487",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 726-215-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ145sqnZDXIYRx8CDu7-Yft8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_187437f97b27ffe386508461",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Kneaders Bakery & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11018 Westwood Loop, San Antonio, TX 78253, USA",
      "poi_short_description": "Cafe chain specializing in a variety of breads plus sandwiches, salads, pastries & breakfast fare.",
      "poi_long_description": "Cafe chain specializing in a variety of breads plus sandwiches, salads, pastries & breakfast fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-af2d-743e-8f46-204b068290a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-af2d-743e-8f46-204b068290a9",
        "storage_key": "property/5764347288616960/019f14e9-af2d-743e-8f46-204b068290a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kneaders.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18404906236688010566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kneaders-bakery--cafe",
      "poi_latitude": "29.4950231",
      "poi_longitude": "-98.709724",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-200-7976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0ce1-7734-a7e5-d1654f1288eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0ce1-7734-a7e5-d1654f1288eb",
        "storage_key": "property/5764347288616960/019f14ea-0ce1-7734-a7e5-d1654f1288eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7eyihHtCXIYRRg0perVca_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_74f2e114b63f6e7c502fc478",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Schlotzsky's Deli",
      "poi_type": "Restaurants",
      "poi_address": "11010 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Counter-serve chain serving deli fare, such as their Original sandwich, specialty pizzas & salads.",
      "poi_long_description": "Counter-serve chain serving deli fare, such as their Original sandwich, specialty pizzas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-abfd-76ea-8331-105d0d7214d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-abfd-76ea-8331-105d0d7214d0",
        "storage_key": "property/5764347288616960/019f14e9-abfd-76ea-8331-105d0d7214d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.schlotzskys.com/tx/san-antonio/11010-culebra-road?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=5329888310939319413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schlotzskys-deli",
      "poi_latitude": "29.4960398",
      "poi_longitude": "-98.7113028",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-688-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs67_6HtCXIYRdXwLCi6R90k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_f19f249eda83d06c10767e17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Wok Inn",
      "poi_type": "Restaurants",
      "poi_address": "10919 Culebra Rd #170, San Antonio, TX 78253, USA",
      "poi_short_description": "Local chain serving a menu of Pan-Asian dishes in a casual, contemporary setting.",
      "poi_long_description": "Local chain serving a menu of Pan-Asian dishes in a casual, contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-b0d1-74ca-9fce-01be40cec373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b0d1-74ca-9fce-01be40cec373",
        "storage_key": "property/5764347288616960/019f14e9-b0d1-74ca-9fce-01be40cec373.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wok-inn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11674656761348234744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wok-inn",
      "poi_latitude": "29.49722449999999",
      "poi_longitude": "-98.7083969",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-682-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbctmW3xCXIYR-B3GLni2BKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_7c6d51e1f10ba1a50d89027f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "El Rodeo de Jalisco",
      "poi_type": "Restaurants",
      "poi_address": "11282 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare and margaritas for breakfast, lunch, and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-a44e-768b-9cc5-4ba2bfa65b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a44e-768b-9cc5-4ba2bfa65b10",
        "storage_key": "property/5764347288616960/019f14e9-a44e-768b-9cc5-4ba2bfa65b10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/RodeoAlamoRanch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887159240405436940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rodeo-de-jalisco",
      "poi_latitude": "29.4974741",
      "poi_longitude": "-98.715229",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-257-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-3NVXdCXIYRDEp6gaX1Fpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_2b9d698af468d9eca781a6d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Mama Margies Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10927 FM471, San Antonio, TX 78253, USA",
      "poi_short_description": "Outpost of a casual 24-hour chain with Tex-Mex fare, frozen cocktails, happy hour & a drive-thru.",
      "poi_long_description": "Outpost of a casual 24-hour chain with Tex-Mex fare, frozen cocktails, happy hour & a drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-a43e-76d5-a31d-b7ac33750d25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a43e-76d5-a31d-b7ac33750d25",
        "storage_key": "property/5764347288616960/019f14e9-a43e-76d5-a31d-b7ac33750d25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mamamargies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9261038845398978382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mama-margies-mexican-restaurant",
      "poi_latitude": "29.4961474",
      "poi_longitude": "-98.7084824",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-277-7090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbctmW3xCXIYRTo8ZR8PRhYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_51c9dbb86ee123b971adf28f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "46th St. New York Style Pizzeria/Alamo Ranch",
      "poi_type": "Restaurants",
      "poi_address": "11282 Culebra Rd #113, San Antonio, TX 78253, USA",
      "poi_short_description": "Casual, NY-style pizzeria offering large pies, fried mozzarella and other Italian classics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-ab73-731c-9059-93336ba1ec54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-ab73-731c-9059-93336ba1ec54",
        "storage_key": "property/5764347288616960/019f14e9-ab73-731c-9059-93336ba1ec54.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.46st-pizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16449059113070335920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "46th-st-new-york-style-pizzeriaalamo-ranch",
      "poi_latitude": "29.4975447",
      "poi_longitude": "-98.7153279",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-688-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-3NVXdCXIYRsJf1yxzMRuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_9fe7255a24ed027bb4372b7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Kumori Sushi & Teppanyaki",
      "poi_type": "Restaurants",
      "poi_address": "5519 W Loop 1604 N Ste 101, San Antonio, TX 78253, USA",
      "poi_short_description": "Local Japanese chain serving sushi, teppanyaki & cocktails in a contemporary setting.",
      "poi_long_description": "Local Japanese chain serving sushi, teppanyaki & cocktails in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-bf87-7004-b2c4-82a3531b48b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-bf87-7004-b2c4-82a3531b48b1",
        "storage_key": "property/5764347288616960/019f14e9-bf87-7004-b2c4-82a3531b48b1.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://kumorisushi.com/san-antonio-menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6195348865391870197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kumori-sushi--teppanyaki",
      "poi_latitude": "29.4914397",
      "poi_longitude": "-98.7088278",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-251-3804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Uh5TmNCXIYR9UBN_fdM-lU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_cddd2f98a442dd9d335e867d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Fish City Grill",
      "poi_type": "Restaurants",
      "poi_address": "7010 W Loop 1604 N Ste 111, San Antonio, TX 78254, USA",
      "poi_short_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_long_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-bf34-72df-8939-f951473801ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-bf34-72df-8939-f951473801ca",
        "storage_key": "property/5764347288616960/019f14e9-bf34-72df-8939-f951473801ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fishcitygrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16371756545471983180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fish-city-grill",
      "poi_latitude": "29.502675",
      "poi_longitude": "-98.6996118",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-455-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSmdopFDXIYRTK4IOtYpNOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_9bdeca1ef788b77abaa0a5cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "54th Street Scratch Grill & Bar- Shoppes of Culebra",
      "poi_type": "Restaurants",
      "poi_address": "5722 W Loop 1604 N, San Antonio, TX 78251, USA",
      "poi_short_description": "Chain offering a broad American menu & drinks in a relaxed setting with kitschy, eclectic decor.",
      "poi_long_description": "Chain offering a broad American menu & drinks in a relaxed setting with kitschy, eclectic decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c390-752f-9ff5-fb5e6eb020a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c390-752f-9ff5-fb5e6eb020a7",
        "storage_key": "property/5764347288616960/019f14e9-c390-752f-9ff5-fb5e6eb020a7.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.54thstreetgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9225634535143830853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "54th-street-scratch-grill--bar--shoppes-of-culebra",
      "poi_latitude": "29.4898633",
      "poi_longitude": "-98.7056579",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-684-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3bQG2NCXIYRRfXS7roJCIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c021cd49af24d713ab92019e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "6930 W Loop 1604 N, San Antonio, TX 78254, USA",
      "poi_short_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_long_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c390-752f-9ff5-ffa9997f9ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c390-752f-9ff5-ffa9997f9ccc",
        "storage_key": "property/5764347288616960/019f14e9-c390-752f-9ff5-ffa9997f9ccc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bubbas33.com/locations/texas/san-antonio-nw?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=8543521337603796728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "29.5017268",
      "poi_longitude": "-98.699949",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-591-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0icprVDXIYR-C7YGmSvkHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_55d8c519d7b4fae7396fd3b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "12034 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c775-7213-b7cc-47b669718b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c775-7213-b7cc-47b669718b45",
        "storage_key": "property/5764347288616960/019f14e9-c775-7213-b7cc-47b669718b45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/tx/san-antonio/12034-culebra-rd.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=3090924068675913510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "29.5034569",
      "poi_longitude": "-98.7307185",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-775-2350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcD0duppXIYRJgciZRAr5So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_808fe4dddb24ddcd9cffc67f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "11003 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c3db-73ee-a967-0fc0fa1e5bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c3db-73ee-a967-0fc0fa1e5bf7",
        "storage_key": "property/5764347288616960/019f14e9-c3db-73ee-a967-0fc0fa1e5bf7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/san-antonio/11003-culebra-rd/2741062?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11654841206028679981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.4967887",
      "poi_longitude": "-98.7098212",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-688-0845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0c96-7639-ab67-f26e54f4690a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0c96-7639-ab67-f26e54f4690a",
        "storage_key": "property/5764347288616960/019f14ea-0c96-7639-ab67-f26e54f4690a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJjf___z9AXIYRLbvsrlNQvqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_f2888255092dc2f5fd72da85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "11880 FM471, San Antonio, TX 78253, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-cb5a-71db-8ee5-cc6a874ad19d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-cb5a-71db-8ee5-cc6a874ad19d",
        "storage_key": "property/5764347288616960/019f14e9-cb5a-71db-8ee5-cc6a874ad19d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/san-antonio/11880-w-fm-471/2741056?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1213795418477432851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.5021725",
      "poi_longitude": "-98.7276162",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-688-6401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0c96-7639-ab67-f26e54f4690a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0c96-7639-ab67-f26e54f4690a",
        "storage_key": "property/5764347288616960/019f14ea-0c96-7639-ab67-f26e54f4690a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJR8QqhD5fXIYRExBYjIBE2BA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_65892aa5eea0364c7aafb523",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "12020 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-d374-74f0-b304-0fb0f43457a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d374-74f0-b304-0fb0f43457a0",
        "storage_key": "property/5764347288616960/019f14e9-d374-74f0-b304-0fb0f43457a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12020+culebra+rd-san+antonio-tx-78253/id=12716",
      "poi_directions_map_url": "https://maps.google.com/?cid=7570064444363252055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.502658",
      "poi_longitude": "-98.7287852",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-762-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VE5rfxpXIYRVyEWFYFFDmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2adfc7be56f2ccb202f74fe2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "13343 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c698-760a-bc27-06ec342d986a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c698-760a-bc27-06ec342d986a",
        "storage_key": "property/5764347288616960/019f14e9-c698-760a-bc27-06ec342d986a.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/13343-culebra-road-san-antonio-tx-78253/storeid=10905?WT.mc_id=LS_GOOGLE_RX_10905",
      "poi_directions_map_url": "https://maps.google.com/?cid=15976372729929791875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.51585369999999",
      "poi_longitude": "-98.7591328",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-507-5641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0ce3-7779-8e6e-3caf2181ddd2",
        "storage_key": "property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc58i-MVrXIYRg_mz9ll6t90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0ae71995b2366f87c9b39867",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Popeyes Louisiana Kitchen",
      "poi_type": "Shopping & Retail",
      "poi_address": "11115 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_long_description": "Louisiana-inspired fast-food chain known for its crispy fried chicken, chicken sandwiches & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c7d3-74da-9e3f-ae673b1cf900.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c7d3-74da-9e3f-ae673b1cf900",
        "storage_key": "property/5764347288616960/019f14e9-c7d3-74da-9e3f-ae673b1cf900.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.popeyes.com/store-locator/store/restaurant_84880",
      "poi_directions_map_url": "https://maps.google.com/?cid=12443537836278460250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popeyes-louisiana-kitchen",
      "poi_latitude": "29.4973606",
      "poi_longitude": "-98.7117627",
      "poi_miles_from_property": "295 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-688-9438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_ZC23tCXIYRWq-CwLtTsKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_0df776b14f5f19cd32bb8943",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "11210 Potranco Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Clean-cut chain offering a large selection of groceries, toys, appliances, electronics and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-d2b8-757d-b83c-48da5875efcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d2b8-757d-b83c-48da5875efcd",
        "storage_key": "property/5764347288616960/019f14e9-d2b8-757d-b83c-48da5875efcd.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3888-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11468842206352477860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.4337315",
      "poi_longitude": "-98.713535",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-679-7184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-5452-73de-8bb6-40577cf316a8",
        "storage_key": "property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn9m9kqJDXIYRpI6l3jiDKZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_6574314a1089b7e03d7268ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9005 FM1560, San Antonio, TX 78254, USA",
      "poi_short_description": "Neighborhood grocery store selling produce, baked goods and other grocery items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-d4be-7100-801e-7b3f98b40d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d4be-7100-801e-7b3f98b40d23",
        "storage_key": "property/5764347288616960/019f14e9-d4be-7100-801e-7b3f98b40d23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/5490-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6912468647232128358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "29.5252359",
      "poi_longitude": "-98.7190953",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-507-0834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54c2-713b-8aaa-e31b857aa873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54c2-713b-8aaa-e31b857aa873",
        "storage_key": "property/5764347288616960/019f14e8-54c2-713b-8aaa-e31b857aa873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78YA0sRpXIYRZsVLX5wF7l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_f983972671d5d14148abeba5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "15489 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-d1de-722d-92d4-65d08cc7a754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d1de-722d-92d4-65d08cc7a754",
        "storage_key": "property/5764347288616960/019f14e9-d1de-722d-92d4-65d08cc7a754.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/tx/san-antonio/culebra-and-211-h-e-b-807?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=1788049364146305266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.5237606",
      "poi_longitude": "-98.80410030000002",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 726-220-5239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54c2-713b-8aaa-e31b857aa873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54c2-713b-8aaa-e31b857aa873",
        "storage_key": "property/5764347288616960/019f14e8-54c2-713b-8aaa-e31b857aa873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-LMcONrXIYR8rjNVmxt0Bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ab26d3cddbb52dcabf12d637",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5355 W Loop 1604 N, San Antonio, TX 78253, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-dfa8-7307-b092-3d1e3e622195.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-dfa8-7307-b092-3d1e3e622195",
        "storage_key": "property/5764347288616960/019f14e9-dfa8-7307-b092-3d1e3e622195.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/san-antonio-culebra/2426",
      "poi_directions_map_url": "https://maps.google.com/?cid=5511033384945262135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.4931323",
      "poi_longitude": "-98.7102076",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-424-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-5452-73de-8bb6-40577cf316a8",
        "storage_key": "property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE_xSoHxCXIYRNx77Nqofe0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_8cab219a7f39ba652dd138fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "SST Northwest",
      "poi_type": "Education",
      "poi_address": "12042 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-dbbe-76f0-a60a-572c77840e50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-dbbe-76f0-a60a-572c77840e50",
        "storage_key": "property/5764347288616960/019f14e9-dbbe-76f0-a60a-572c77840e50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sstschools.org/location/northwest/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9872667074540521202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sst-northwest",
      "poi_latitude": "29.50268119999999",
      "poi_longitude": "-98.7313121",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-688-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbVMPnQdpXIYR8saui2XCAok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_16d89782b7f25f3919ccebab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Alphabetz Montessori",
      "poi_type": "Education",
      "poi_address": "12026 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Montessori-based kindergarten focusing on hands-on lessons while promoting coordination and independence.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-d8f5-76e1-8b33-f0c4500454fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d8f5-76e1-8b33-f0c4500454fb",
        "storage_key": "property/5764347288616960/019f14e9-d8f5-76e1-8b33-f0c4500454fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alphabetzmontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14143443271459061176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alphabetz-montessori",
      "poi_latitude": "29.5028495",
      "poi_longitude": "-98.7292938",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-350-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwxx_DVRpXIYRuL00YLiaR8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d4ee3bac94880ecea06853a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Little Treehouse Early Learning Center #2",
      "poi_type": "Education",
      "poi_address": "8373 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Day care center and after-school program in the Culebra Crossing Shopping Center.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.littletreehouseelc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17033243658984807131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-treehouse-early-learning-center-2",
      "poi_latitude": "29.4703845",
      "poi_longitude": "-98.6487064",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-681-5323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZbB9eyVdXIYR29p2otw8Yuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_76226b9a91eef453e4c273b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Judge Andy Mireles Elementary School",
      "poi_type": "Education",
      "poi_address": "12260 Rockwall Mill, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-de06-7038-b573-55eef57fac0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-de06-7038-b573-55eef57fac0d",
        "storage_key": "property/5764347288616960/019f14e9-de06-7038-b573-55eef57fac0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/mireles/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13392560328693019052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "judge-andy-mireles-elementary-school",
      "poi_latitude": "29.4917703",
      "poi_longitude": "-98.7354596",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-398-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD8zBsQ9CXIYRrHG8gKnu27k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6a1963a3cc584ce962fda40d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Bennie L. Cole Elementary School",
      "poi_type": "Education",
      "poi_address": "13185 Tillman Ridge, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/cole",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811319786672910562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bennie-l-cole-elementary-school",
      "poi_latitude": "29.45645349999999",
      "poi_longitude": "-98.7549156",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-398-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx5kWMoJBXIYR4nCqcnPQAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_97d44671bc69ba804700e99a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "John Hoffmann Elementary School",
      "poi_type": "Education",
      "poi_address": "12118 Volunteer Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/hoffmann",
      "poi_directions_map_url": "https://maps.google.com/?cid=874388922217892709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-hoffmann-elementary-school",
      "poi_latitude": "29.4766805",
      "poi_longitude": "-98.7320957",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-397-8350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ16Uh2z1CXIYRZYtVkBd0Igw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_89ae14286a409fe65885445b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Gregory Luna Middle School",
      "poi_type": "Education",
      "poi_address": "200 N Grosenbacher Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e323-70fe-810b-9ef67628e2d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e323-70fe-810b-9ef67628e2d3",
        "storage_key": "property/5764347288616960/019f14e9-e323-70fe-810b-9ef67628e2d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nisd.net/luna/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8650500154414211951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gregory-luna-middle-school",
      "poi_latitude": "29.4340688",
      "poi_longitude": "-98.737586",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-397-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL3PbNt1DXIYRbyNS4Q7ADHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3f5c99dbd99e940f7af6bf8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "John M. Harlan High School",
      "poi_type": "Education",
      "poi_address": "14350 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e18e-71dc-ba81-2f29dfa3fa4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e18e-71dc-ba81-2f29dfa3fa4d",
        "storage_key": "property/5764347288616960/019f14e9-e18e-71dc-ba81-2f29dfa3fa4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nisd.net/harlan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11229204069306120481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-m-harlan-high-school",
      "poi_latitude": "29.5154961",
      "poi_longitude": "-98.7800205",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-398-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq_PEtnJqXIYRIblcLZsl1ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_8598f45fa172c21000be347c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "William J. Brennan High School",
      "poi_type": "Education",
      "poi_address": "2400 Cottonwood Way, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-de05-7218-90b1-2b865b6cebda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-de05-7218-90b1-2b865b6cebda",
        "storage_key": "property/5764347288616960/019f14e9-de05-7218-90b1-2b865b6cebda.webp",
        "width": 876,
        "height": 580
      },
      "poi_business_url": "https://nisd.net/brennan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11412433271138886541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-brennan-high-school",
      "poi_latitude": "29.457912",
      "poi_longitude": "-98.7246428",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-398-1250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK8IbgkpCXIYRjSMVLZgbYZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_f68f41f65299ac12a82c201f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Education",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-3722-77db-b72e-c1d4d3920cc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-3722-77db-b72e-c1d4d3920cc3",
        "storage_key": "property/5764347288616960/019f14e7-3722-77db-b72e-c1d4d3920cc3.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9dc12e0e0fccc80e155ffab9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Santikos Casa Blanca",
      "poi_type": "Entertainment",
      "poi_address": "11210 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "Movie theater showing the newest releases, as well as gourmet eats served in theater.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-dfad-75ed-8a0f-e5ddd8c30643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-dfad-75ed-8a0f-e5ddd8c30643",
        "storage_key": "property/5764347288616960/019f14e9-dfad-75ed-8a0f-e5ddd8c30643.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/casa-blanca/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9204084987399822335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-casa-blanca",
      "poi_latitude": "29.4839101",
      "poi_longitude": "-98.7145134",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0c8c-73a1-b456-baa5f2f72f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0c8c-73a1-b456-baa5f2f72f86",
        "storage_key": "property/5764347288616960/019f14ea-0c8c-73a1-b456-baa5f2f72f86.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7VHQZWZCXIYR_9t43Id6u38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_3ed01b792b39148c9891f1ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4805-722b-b7ed-f011eac3463c",
        "storage_key": "property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_c5cd0a831a73168681f80aed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Government Canyon State Natural Area",
      "poi_type": "Entertainment",
      "poi_address": "12861 Galm Rd, San Antonio, TX 78254, USA",
      "poi_short_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_long_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-791c-70cf-8ad9-07fe03722a9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-791c-70cf-8ad9-07fe03722a9b",
        "storage_key": "property/5764347288616960/019f14e7-791c-70cf-8ad9-07fe03722a9b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/government-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615951085383130630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-canyon-state-natural-area",
      "poi_latitude": "29.549356",
      "poi_longitude": "-98.764798",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-688-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWz1--NrXIYRBh6T3PclNKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_1254dd4b9a8d2d892b4b7fea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Santikos Palladium",
      "poi_type": "Entertainment",
      "poi_address": "17703 W Interstate 10 Frontage Rd, San Antonio, TX 78257, USA",
      "poi_short_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_long_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e3e6-727b-a9e5-2668b13f5cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e3e6-727b-a9e5-2668b13f5cc2",
        "storage_key": "property/5764347288616960/019f14e9-e3e6-727b-a9e5-2668b13f5cc2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/palladium/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8534017591422902188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-palladium",
      "poi_latitude": "29.6085339",
      "poi_longitude": "-98.5992852",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0c8c-73a1-b456-baa5f2f72f86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0c8c-73a1-b456-baa5f2f72f86",
        "storage_key": "property/5764347288616960/019f14ea-0c8c-73a1-b456-baa5f2f72f86.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZDq_iNkXIYRrF-yw8jrbnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_8da67c4561892d5d9653090a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Topgolf San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "5539 N Loop 1604 W, San Antonio, TX 78249, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e5ec-71fe-af15-5228b47d1206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e5ec-71fe-af15-5228b47d1206",
        "storage_key": "property/5764347288616960/019f14e9-e5ec-71fe-af15-5228b47d1206.webp",
        "width": 800,
        "height": 525
      },
      "poi_business_url": "https://topgolf.com/us/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18114592869921636103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-san-antonio",
      "poi_latitude": "29.5940894",
      "poi_longitude": "-98.5950414",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-202-2694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ8Xo5hmXIYRB7-Abj32Y_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_83ce7f792921b0b03d1f4bcb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e9c6-74b9-b354-e25239d49ff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e9c6-74b9-b354-e25239d49ff7",
        "storage_key": "property/5764347288616960/019f14e9-e9c6-74b9-b354-e25239d49ff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_bfd8e0ef9191c87d5ee113c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "The Shops at La Cantera",
      "poi_type": "Entertainment",
      "poi_address": "15900 La Cantera Pkwy Ste 6698, San Antonio, TX 78256, USA",
      "poi_short_description": "Upscale shopping center along an outdoor mall-style walkway with a wide variety of restaurants, shops and food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-eda9-77fe-85c2-93025b90e343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-eda9-77fe-85c2-93025b90e343",
        "storage_key": "property/5764347288616960/019f14e9-eda9-77fe-85c2-93025b90e343.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theshopsatlacantera.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11016393100736632124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-la-cantera",
      "poi_latitude": "29.5922066",
      "poi_longitude": "-98.6153483",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-582-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-5452-73de-8bb6-40577cf316a8",
        "storage_key": "property/5764347288616960/019f14e8-5452-73de-8bb6-40577cf316a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4RQtcodmXIYRPJV4YygX4pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ba1e5192895db09c441da688",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "iFLY Indoor Skydiving - San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "15915 I-10, San Antonio, TX 78249, USA",
      "poi_short_description": "Indoor skydiving facility with a wind tunnel where experienced instructors offer training and guidance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e907-7037-9a64-cfdeea8e3e56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e907-7037-9a64-cfdeea8e3e56",
        "storage_key": "property/5764347288616960/019f14e9-e907-7037-9a64-cfdeea8e3e56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.iflyworld.com/san-antonio?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8097754445672492456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---san-antonio",
      "poi_latitude": "29.592967",
      "poi_longitude": "-98.597387",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-762-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2iT5K56XIYRqC2mvMMAYXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_d122d777a856bf6f96052c0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Bowl & Barrel",
      "poi_type": "Entertainment",
      "poi_address": "17619 La Cantera Pkwy #102, San Antonio, TX 78257, USA",
      "poi_short_description": "Stylish bowling alley featuring elevated bar fare alongside wine, craft beer & spirits.",
      "poi_long_description": "Stylish bowling alley featuring elevated bar fare alongside wine, craft beer & spirits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e965-70ac-85d1-08b5e6afd7a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e965-70ac-85d1-08b5e6afd7a7",
        "storage_key": "property/5764347288616960/019f14e9-e965-70ac-85d1-08b5e6afd7a7.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.bowlandbarrel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10072841705768394120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowl--barrel",
      "poi_latitude": "29.60973899999999",
      "poi_longitude": "-98.598057",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-920-1102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZ8mwCNkXIYRiJ0QxynsyYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6a8577068d0f1f7bb977f207",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "San Antonio Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "6320 Bandera Rd, Leon Valley, TX 78238, USA",
      "poi_short_description": "Small, interactive aquarium offering touch tanks, fish feeding, an aviary & an inflatable play area.",
      "poi_long_description": "Small, interactive aquarium offering touch tanks, fish feeding, an aviary & an inflatable play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-421d-71aa-9209-b3b10cbace8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-421d-71aa-9209-b3b10cbace8c",
        "storage_key": "property/5764347288616960/019f14e7-421d-71aa-9209-b3b10cbace8c.webp",
        "width": 1280,
        "height": 638
      },
      "poi_business_url": "http://www.sanantonioaquarium.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11944832552059421882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-aquarium",
      "poi_latitude": "29.4871014",
      "poi_longitude": "-98.6097745",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-310-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3euEkJhdXIYRukQGb-uRxKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_3e9f7587779a246991eb4351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "The Emergency Center at Alamo Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "11320 Alamo Ranch Pkwy, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f000-73c4-bbe7-3eaff7957a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f000-73c4-bbe7-3eaff7957a49",
        "storage_key": "property/5764347288616960/019f14e9-f000-73c4-bbe7-3eaff7957a49.webp",
        "width": 1280,
        "height": 965
      },
      "poi_business_url": "https://www.theemergencycenter.com/san-antonio-er/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174052364480615231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-emergency-center-at-alamo-ranch",
      "poi_latitude": "29.485643",
      "poi_longitude": "-98.7154285",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-485-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbi8SG9CXIYRPxOTtGcSSxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_4e7be06ac82ef233243a144a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "NextCare Urgent Care, San Antonio (Culebra Rd)",
      "poi_type": "Health and Wellness",
      "poi_address": "11282 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-ecfb-729e-b315-f028abbcdc67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-ecfb-729e-b315-f028abbcdc67",
        "storage_key": "property/5764347288616960/019f14e9-ecfb-729e-b315-f028abbcdc67.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nextcare.com/locations/tx/san-antonio-culebra-rd/?utm_source=google&utm_medium=organic&utm_campaign=google_maps&utm_content=culebra",
      "poi_directions_map_url": "https://maps.google.com/?cid=13278456892973274484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care-san-antonio-culebra-rd",
      "poi_latitude": "29.4974358",
      "poi_longitude": "-98.7152093",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-802-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJubokXHdCXIYRdFUCHzGORrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_07bebc09cc6254bdffac806f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "CHRISTUS Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11823 Culebra Rd #105, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-eaf5-75ab-84c6-83c5eedea6ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-eaf5-75ab-84c6-83c5eedea6ae",
        "storage_key": "property/5764347288616960/019f14e9-eaf5-75ab-84c6-83c5eedea6ae.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.christushealth.org/locations/urgent-care-carmel-canyon?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4870554325604034640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-urgent-care",
      "poi_latitude": "29.5028291",
      "poi_longitude": "-98.7260674",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-598-1517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8plCOBpXIYRUOjelFqvl0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c98d7be005bde15f405259f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Tots ‘N’ Teens Pediatric Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11019 Culebra Rd Ste 155, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-ec9c-72da-a000-27abd29bac85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-ec9c-72da-a000-27abd29bac85",
        "storage_key": "property/5764347288616960/019f14e9-ec9c-72da-a000-27abd29bac85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.totsnteenspediatric.com/?y_source=1_ODk5OTE2Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1609536163112332935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tots-n-teens-pediatric-urgent-care",
      "poi_latitude": "29.4978172",
      "poi_longitude": "-98.7103128",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-267-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYZVAnxCXIYRh65015w4VhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_30c7167c973645046f03f452",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "13343 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-c698-760a-bc27-06ec342d986a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c698-760a-bc27-06ec342d986a",
        "storage_key": "property/5764347288616960/019f14e9-c698-760a-bc27-06ec342d986a.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/13343-culebra-road-san-antonio-tx-78253/storeid=10905?WT.mc_id=LS_GOOGLE_RX_10905",
      "poi_directions_map_url": "https://maps.google.com/?cid=15976372729929791875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.51585369999999",
      "poi_longitude": "-98.7591328",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-507-5641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0ce3-7779-8e6e-3caf2181ddd2",
        "storage_key": "property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc58i-MVrXIYRg_mz9ll6t90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_78fbcc7c3bdeff5c830fffcc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12020 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-eda6-7656-84fb-c50aa6e43e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-eda6-7656-84fb-c50aa6e43e8c",
        "storage_key": "property/5764347288616960/019f14e9-eda6-7656-84fb-c50aa6e43e8c.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-12020+culebra+rd-san+antonio-tx-78253/id=12716",
      "poi_directions_map_url": "https://maps.google.com/?cid=3707834479574217219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.5026528",
      "poi_longitude": "-98.7287796",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-762-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0ce3-7779-8e6e-3caf2181ddd2",
        "storage_key": "property/5764347288616960/019f14ea-0ce3-7779-8e6e-3caf2181ddd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyR9QLeBpXIYRA3L3cNDfdDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2c8b7edb34846ec0c094ea26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "14124 Culebra Rd Ste 110, San Antonio, TX 78253, USA",
      "poi_short_description": "Neighborhood gym offering a variety of cardio and strength-training equipment, plus group classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f1e5-741c-8158-0b1b22d5a2c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f1e5-741c-8158-0b1b22d5a2c3",
        "storage_key": "property/5764347288616960/019f14e9-f1e5-741c-8158-0b1b22d5a2c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/san-antonio-texas-5213/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=5213",
      "poi_directions_map_url": "https://maps.google.com/?cid=5977595768261135593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "29.5176731",
      "poi_longitude": "-98.776835",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-625-3828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI7PEd6trXIYR6UwVOq6v9FI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0c8390a6036241e88d0317d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11019 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-5150-771e-ab35-47bb86b6c2ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-5150-771e-ab35-47bb86b6c2ca",
        "storage_key": "property/5764347288616960/019f14e7-5150-771e-ab35-47bb86b6c2ca.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-antonio-westwood-center-tx?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2081815221522363099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.4977749",
      "poi_longitude": "-98.7099774",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 830-689-5745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbrXMlVDXIYR23LX_ukX5Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_fa85e9ab44a998c3009342f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Gold's Gym San Antonio Culebra",
      "poi_type": "Health and Wellness",
      "poi_address": "10455 Culebra Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Gym chain with an all-season lap pool, cardio cinema, and heated hot tub, plus personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-2c1f-7128-a9b5-398f3b2fd42c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-2c1f-7128-a9b5-398f3b2fd42c",
        "storage_key": "property/5764347288616960/019f14e8-2c1f-7128-a9b5-398f3b2fd42c.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.goldsgym.com/san-antonio-culebra/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7229306167836890400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golds-gym-san-antonio-culebra",
      "poi_latitude": "29.4913589",
      "poi_longitude": "-98.6966416",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-202-2052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw1dADo9CXIYRIFV1OqinU2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0320ef0710a4da51fa34c34f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "HOTWORX - San Antonio, TX - Potranco",
      "poi_type": "Health and Wellness",
      "poi_address": "12047 Potranco Rd #108, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f0bd-75bb-b667-d4db879960dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f0bd-75bb-b667-d4db879960dc",
        "storage_key": "property/5764347288616960/019f14e9-f0bd-75bb-b667-d4db879960dc.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/sanantonio-potranco?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4204677769398381077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---san-antonio-tx---potranco",
      "poi_latitude": "29.4309962",
      "poi_longitude": "-98.7321232",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 830-468-9679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3cxan3pDXIYRFer4ZycEWjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_5e862bf68ea8d75af28a6a76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Culebra Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10919 Westwood Loop, San Antonio, TX 78254, USA",
      "poi_short_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_long_description": "Roughly 145 acres boasting grassy & wooded areas, a walking trail & multipurpose sport fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f2e7-74f8-8ae4-d00dff0bccb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f2e7-74f8-8ae4-d00dff0bccb9",
        "storage_key": "property/5764347288616960/019f14e9-f2e7-74f8-8ae4-d00dff0bccb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Culebra-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012182010559695994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra-creek-park",
      "poi_latitude": "29.4983731",
      "poi_longitude": "-98.7088968",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWly9nhCXIYReoxbjTEh05g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cda5e8d6025b07ad30ca319e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Cathedral Rock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8002 Grissom Rd, San Antonio, TX 78251, USA",
      "poi_short_description": "Leafy local park with cycling & walking trails, play equipment, a pavilion & picnic tables.",
      "poi_long_description": "Leafy local park with cycling & walking trails, play equipment, a pavilion & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-aebb-7758-939b-d6b774b31252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-aebb-7758-939b-d6b774b31252",
        "storage_key": "property/5764347288616960/019f14e7-aebb-7758-939b-d6b774b31252.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2443/Cathedral-Rock-Park?Park=34&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=3192952255958149799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cathedral-rock-park",
      "poi_latitude": "29.4772582",
      "poi_longitude": "-98.6453105",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-W-DtztdXIYRp-oq6SilTyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_03cb043078b19b467405eb3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Terra Oak Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10140 Terra Oak, San Antonio, TX 78250, USA",
      "poi_short_description": "Paved trail winding through wildflowers and shaded trees for walking and jogging.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f5d1-722f-90d3-9287379d7788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f5d1-722f-90d3-9287379d7788",
        "storage_key": "property/5764347288616960/019f14e9-f5d1-722f-90d3-9287379d7788.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16182258424388281884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terra-oak-trailhead",
      "poi_latitude": "29.506403",
      "poi_longitude": "-98.6915441",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbb4uCdoXIYRHGY8uUzukuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3a3aa3dda14e1d313d414e22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Government Canyon State Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12861 Galm Rd, San Antonio, TX 78254, USA",
      "poi_short_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_long_description": "Tranquil park featuring multi-use trails from rugged to beginner-friendly, plus guided canyon hikes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-791c-70cf-8ad9-07fe03722a9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-791c-70cf-8ad9-07fe03722a9b",
        "storage_key": "property/5764347288616960/019f14e7-791c-70cf-8ad9-07fe03722a9b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tpwd.texas.gov/state-parks/government-canyon",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615951085383130630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "government-canyon-state-natural-area",
      "poi_latitude": "29.549356",
      "poi_longitude": "-98.764798",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-688-9055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWz1--NrXIYRBh6T3PclNKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_37caca8512e9bd87896f4bea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Tom Slick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Texas 151 Access Rd, San Antonio, TX 78227, USA",
      "poi_short_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_long_description": "Suburban park with a 1-acre dog area, pond & baseball, football & soccer fields & pavilion for hire.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f7e6-70d6-abcd-bdb7a768ab73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f7e6-70d6-abcd-bdb7a768ab73",
        "storage_key": "property/5764347288616960/019f14e9-f7e6-70d6-abcd-bdb7a768ab73.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2493/Slick-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013846829374659664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-slick-park",
      "poi_latitude": "29.4304963",
      "poi_longitude": "-98.6347818",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETeE8pZcXIYRUFy0z2wMtDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c8730f6bd1f4291b17b8f057",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "O. P. Schnabel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9606 Bandera Rd, San Antonio, TX 78250, USA",
      "poi_short_description": "Sprawling 202-acre park with nature trails, pavilions, picnic tables, athletic fields & a playscape.",
      "poi_long_description": "Sprawling 202-acre park with nature trails, pavilions, picnic tables, athletic fields & a playscape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-716f-7568-a7b7-25e2191de877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-716f-7568-a7b7-25e2191de877",
        "storage_key": "property/5764347288616960/019f14e7-716f-7568-a7b7-25e2191de877.webp",
        "width": 1209,
        "height": 1280
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/O-P-Schnabel",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813810842197915761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "o-p-schnabel-park",
      "poi_latitude": "29.53512",
      "poi_longitude": "-98.6407568",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2w2aH8FnXIYRcXjRqeCnVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_42570e50be0e75a33d863dbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Nani Falcone Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8701 Mystic Park, San Antonio, TX 78254, USA",
      "poi_short_description": "Park featuring a mile-long walking trail that leads past playgrounds & a disc-golf course.",
      "poi_long_description": "Park featuring a mile-long walking trail that leads past playgrounds & a disc-golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f63a-7027-9cc1-74a66ab5cced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f63a-7027-9cc1-74a66ab5cced",
        "storage_key": "property/5764347288616960/019f14e9-f63a-7027-9cc1-74a66ab5cced.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Falcone-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872024870872701282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nani-falcone-community-park",
      "poi_latitude": "29.524103",
      "poi_longitude": "-98.643443",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCwkM6e5nXIYRYlk8lc7onEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9b6fb4a3eaee36358eca0679",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4805-722b-b7ed-f011eac3463c",
        "storage_key": "property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_d31e4ddf488a8e929f17ac29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "MainLand Trail Head",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8241 Mainland Dr, San Antonio, TX 78250, USA",
      "poi_short_description": "Park with trails for biking and running, as well as public restrooms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f69c-742d-8903-bdfdd53e3b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f69c-742d-8903-bdfdd53e3b71",
        "storage_key": "property/5764347288616960/019f14e9-f69c-742d-8903-bdfdd53e3b71.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "http://www.sanantonio.gov/GreenwayTrails",
      "poi_directions_map_url": "https://maps.google.com/?cid=987313845868802914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainland-trail-head",
      "poi_latitude": "29.5185622",
      "poi_longitude": "-98.6316871",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8",
        "storage_key": "property/5764347288616960/019f14e8-54bf-71a0-bfcc-3ad6ea25e6e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1nFOY5nXIYRYrPVOLaksw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_62cb90eaea5ca06d0cd475ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Bill Miller BBQ",
      "poi_type": "Transportation & Transit",
      "poi_address": "10939 Culebra Rd, San Antonio, TX 78253, USA",
      "poi_short_description": "Laid-back Texas-based chain serving up pit-smoked meats, fried chicken, breakfast & baked goods.",
      "poi_long_description": "Laid-back Texas-based chain serving up pit-smoked meats, fried chicken, breakfast & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-fafb-7773-80c4-88a447208dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-fafb-7773-80c4-88a447208dac",
        "storage_key": "property/5764347288616960/019f14e9-fafb-7773-80c4-88a447208dac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.billmillerbbq.com/locations/bill-miller-62/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13550670228095602974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-miller-bbq",
      "poi_latitude": "29.4963582",
      "poi_longitude": "-98.709005",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-688-2362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b7cb9e0e118d",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b7cb9e0e118d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs67_6HtCXIYRHpEZJsemDbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_3998f3c66a6e466b396e288d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Potranco & Culebra",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8769163869191592415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "potranco--culebra",
      "poi_latitude": "29.455478",
      "poi_longitude": "-98.633874",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYWJuOZcXIYR39la-BNUsnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_fbfad5470cdf608541601efb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "NW Loop 410 S Access Rd & Culebra",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78245, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17897964159602537907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nw-loop-410-s-access-rd--culebra",
      "poi_latitude": "29.45245",
      "poi_longitude": "-98.63113",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezJxv-VcXIYRszXIX5NXYvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_2f62f9068b882c2ebd22691a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Kel-Lac Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7183 Cleto Rodriguez Fwy, San Antonio, TX 78227, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-f912-75ba-846a-0b35aa281b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-f912-75ba-846a-0b35aa281b90",
        "storage_key": "property/5764347288616960/019f14e9-f912-75ba-846a-0b35aa281b90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10271019819885571275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kel-lac-transit-center",
      "poi_latitude": "29.4025405",
      "poi_longitude": "-98.6321479",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-679-0309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5XhLW9bXIYRy6xGpRv-iY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_fd105db9d1249b2e4035dffe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Ingram Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3215 Northwestern Dr, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-fbab-77e8-93ab-bad3c93a02df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-fbab-77e8-93ab-bad3c93a02df",
        "storage_key": "property/5764347288616960/019f14e9-fbab-77e8-93ab-bad3c93a02df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.viainfo.net/transit-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15286896482762599812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-transit-center",
      "poi_latitude": "29.4648153",
      "poi_longitude": "-98.6257608",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-521-6773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryXVZVvZ-4YRhK07jVv3JdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_5e71447893ddeb052c2512e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "VIA Brooks Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7903 S New Braunfels Ave, San Antonio, TX 78223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-faec-727f-bcea-3860c0b1c4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-faec-727f-bcea-3860c0b1c4b3",
        "storage_key": "property/5764347288616960/019f14e9-faec-727f-bcea-3860c0b1c4b3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.viainfo.net/brooks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784373248118960708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-brooks-transit-center",
      "poi_latitude": "29.34627979999999",
      "poi_longitude": "-98.4469207",
      "poi_miles_from_property": "23.3 mi",
      "poi_walking_minutes": "8 hours 31 mins",
      "poi_biking_minutes": "1 hour 59 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 210-362-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8frkSIP3XIYRRDJPCNdbDds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_bfebd6232569e3533e932974",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Randolph Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9400 I-35, San Antonio, TX 78233, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-00fa-74b5-8c12-c2e1fe26811e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-00fa-74b5-8c12-c2e1fe26811e",
        "storage_key": "property/5764347288616960/019f14ea-00fa-74b5-8c12-c2e1fe26811e.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602308921134006725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randolph-park-and-ride",
      "poi_latitude": "29.5244671",
      "poi_longitude": "-98.3923536",
      "poi_miles_from_property": "23.9 mi",
      "poi_walking_minutes": "8 hours 56 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0c96-7639-ab67-ef533d7744fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-0c96-7639-ab67-ef533d7744fb",
        "storage_key": "property/5764347288616960/019f14ea-0c96-7639-ab67-ef533d7744fb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJMct5BLKNXIYRxcHtoTFl5K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_94ea3f9671ebb77c79785414",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-fdd7-737c-b910-06925da36d65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-fdd7-737c-b910-06925da36d65",
        "storage_key": "property/5764347288616960/019f14e9-fdd7-737c-b910-06925da36d65.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 29 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54c4-7489-b161-7cd45b02b6d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54c4-7489-b161-7cd45b02b6d9",
        "storage_key": "property/5764347288616960/019f14e8-54c4-7489-b161-7cd45b02b6d9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_c22580cf1ca483402b6f045a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Culebra & Tally",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78228, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3840325634326882854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culebra--tally",
      "poi_latitude": "29.448022",
      "poi_longitude": "-98.554234",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6zKBR5ReXIYRJmrhR9GTSzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_b959cc5a1650e9c0e31f9fda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-3722-77db-b72e-c1d4d3920cc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-3722-77db-b72e-c1d4d3920cc3",
        "storage_key": "property/5764347288616960/019f14e7-3722-77db-b72e-c1d4d3920cc3.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_3ee29ea4caceaf56f0e4e4ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "SeaWorld San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10500 SeaWorld Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_long_description": "Marine life shows, thrill rides, aquariums & up-close encounters with dolphins, penguins & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4805-722b-b7ed-f011eac3463c",
        "storage_key": "property/5764347288616960/019f14e7-4805-722b-b7ed-f011eac3463c.webp",
        "width": 1280,
        "height": 952
      },
      "poi_business_url": "https://seaworld.com/san-antonio?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8854466051154083971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaworld-san-antonio",
      "poi_latitude": "29.4562822",
      "poi_longitude": "-98.6999612",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-520-4732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9c70gFDXIYRg4DL5vVh4Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_66153535ab9244aeda7410fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e9-e9c6-74b9-b354-e25239d49ff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e9c6-74b9-b354-e25239d49ff7",
        "storage_key": "property/5764347288616960/019f14e9-e9c6-74b9-b354-e25239d49ff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_76a9c9b26a74bb267aaabb84",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "North Central Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 Madison Oak Dr, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-045b-72e3-996e-3ec697319daa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-045b-72e3-996e-3ec697319daa",
        "storage_key": "property/5764347288616960/019f14ea-045b-72e3-996e-3ec697319daa.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/locations/detail/north-central-baptist-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906410289780053303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-baptist-hospital",
      "poi_latitude": "29.6204476",
      "poi_longitude": "-98.4908558",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 1 min",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-297-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b967b3a2c060.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b967b3a2c060",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b967b3a2c060.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwCXMoxjXIYRN1WdEayjeok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2e73e542c014ce4c725b9b60",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Methodist Hospital Stone Oak",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1139 E Sonterra Blvd, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0134-7632-ac75-3d8b81584b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-0134-7632-ac75-3d8b81584b30",
        "storage_key": "property/5764347288616960/019f14ea-0134-7632-ac75-3d8b81584b30.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital-stone-oak?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066658014942627455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital-stone-oak",
      "poi_latitude": "29.6162229",
      "poi_longitude": "-98.4743864",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 16 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 210-638-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54a3-743b-b096-b967b3a2c060.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54a3-743b-b096-b967b3a2c060",
        "storage_key": "property/5764347288616960/019f14e8-54a3-743b-b096-b967b3a2c060.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4q-ivmJXIYRf4bSGQbQEWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f592a49fd1b61f149d367ad3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Northside Independent School District Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5900 Evers Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=592429851399403552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-independent-school-district-administration-building",
      "poi_latitude": "29.4908341",
      "poi_longitude": "-98.6012233",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-397-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7e68JZdXIYRILj_ns-7OAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_9ecf515ba1b7bc8b6ae8b135",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-013f-76eb-9f17-332380ae652f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-013f-76eb-9f17-332380ae652f",
        "storage_key": "property/5764347288616960/019f14ea-013f-76eb-9f17-332380ae652f.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b9de2f6cf2eb987c254c0c81",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "UT Health San Antonio | University of Texas Health Science Center at San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7703 Floyd Curl Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-01ec-7038-81bd-bc48899157a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-01ec-7038-81bd-bc48899157a8",
        "storage_key": "property/5764347288616960/019f14ea-01ec-7038-81bd-bc48899157a8.webp",
        "width": 743,
        "height": 492
      },
      "poi_business_url": "https://uthscsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3360406320502522370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-health-san-antonio--university-of-texas-health-science-center-at-san-antonio",
      "poi_latitude": "29.50809589999999",
      "poi_longitude": "-98.575681",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 210-567-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-54bc-773e-ab56-86e2cb698896",
        "storage_key": "property/5764347288616960/019f14e8-54bc-773e-ab56-86e2cb698896.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnS9zQ_5dXIYRAsKHir6Poi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_ac3f3af84b4904bbfc37ae83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "Rackspace Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "19122 U.S. Hwy 281 N Ste 128, San Antonio, TX 78258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-03f3-7189-aad0-7c99829da14a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-03f3-7189-aad0-7c99829da14a",
        "storage_key": "property/5764347288616960/019f14ea-03f3-7189-aad0-7c99829da14a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rackspace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10903605575149915578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rackspace-technology",
      "poi_latitude": "29.6183163",
      "poi_longitude": "-98.4634525",
      "poi_miles_from_property": "20.7 mi",
      "poi_walking_minutes": "7 hours 39 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 800-961-4454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc1iXP7zXIYRuo3HNYBjUZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_1ad08c03a4a7c8ffd9258be5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "generator",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14ea-0389-721d-9025-cee388f75370.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-0389-721d-9025-cee388f75370",
        "storage_key": "property/5764347288616960/019f14ea-0389-721d-9025-cee388f75370.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.4172323",
      "poi_longitude": "-98.4954226",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e8-549c-73d9-b391-f6a5165e8987",
        "storage_key": "property/5764347288616960/019f14e8-549c-73d9-b391-f6a5165e8987.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c4d6dba5-e9c8-4223-8729-ed00ac5c56d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bbaeeecc-a675-46d4-8958-d62a474bf489",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_acba09ea-da1c-41f3-bbf2-986ad596e24b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_72ff2d32-0592-4de9-b830-0e0765c767b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e7419bfc-7581-4785-9775-a2464ea5c4c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_20de600f-bdad-4ff7-a3b7-566deefb9352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_29182a29839656b67d0942fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "rating": "5",
      "name": "A NV",
      "text": "Everyone wants a place to call home, and everyone wants to feel safe and secure. My family and I have been living here for about a decade now. We have seen many things and many people leave as expected in a community. But one thing is for sure, we are comfortable. Some of our neighbors have been here longer than we have, and we have come to know them and have seen their families grow like ours. No one is perfect, and in a time of uncertainty, being able to call a place like this home and being comfortable is no easy feat for many. When we reach those gates to come in, a sigh of relief passes through, a feeling similar to the expression of, \"we made it.\" I know the experience is different for everyone, but this subjective post is simply that and without bias. Communication is key, if ever you run into an issue with anything on property or unit, talk with property management, they honestly do their best to help, as human beings, we learn from each other, together we can do great things. So, if you are looking for a place to start your roots or something different, then start here. Don't take my word for it, see for yourself, and by the way, if you see us and we smile or say hi, just say hi back, we're not bad people. My wife works with the Air Force and I am a behavior and communications analyst. Have a great day and may you find what you seek.",
      "date": "2026-01-29",
      "title": "false"
    },
    {
      "id": "ec_87a2fb9754bae611845078f7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "rating": "5",
      "name": "Ebony Jones",
      "text": "This Apartment Complex is everything you would expect and more. The Landlords are GREAT and have met every expectation since I’ve been here. I will highly recommend. The maintenance man is Fantastic. He fixed my AC immediately. He also made sure everything in the bathroom was good and working before he left. Any work orders that are assigned to him He gets them done immediately. Everything has been great so far.",
      "date": "2026-04-29",
      "title": "false"
    },
    {
      "id": "ec_2a536e960b3b986bf66da2dc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "rating": "5",
      "name": "noemi quinones",
      "text": "I’ve lived here for almost two years and have renewed my lease once. I have nothing but great things to say about this apartment complex. From the management team to the amenities and the location. I’ve never had a complaint. The community is clean, well maintained, and welcoming. Highly recommend!",
      "date": "2026-04-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c7e4cd22-2aa0-420b-931e-5b4b7ff17cb4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019d02f5-0678-750c-8551-1a80ba625822.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room and kitchen area in apartment with white couch, dining table, and island.",
        "public_id": "019d02f5-0678-750c-8551-1a80ba625822",
        "storage_key": "property/5764347288616960/019d02f5-0678-750c-8551-1a80ba625822.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 658SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kKSWYYABXdR"
    },
    {
      "id": "custom_3610bb48-ac20-4c0a-bd76-fa8874baac32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14c2-c56c-72d0-bf6f-e52756f3e278.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-c56c-72d0-bf6f-e52756f3e278",
        "storage_key": "property/5764347288616960/019f14c2-c56c-72d0-bf6f-e52756f3e278.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2RHhkQBTdha"
    },
    {
      "id": "custom_325fb59e-3678-467a-9a56-37d9555789ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14c2-cd68-75e3-90bc-5b22ab861ed2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-cd68-75e3-90bc-5b22ab861ed2",
        "storage_key": "property/5764347288616960/019f14c2-cd68-75e3-90bc-5b22ab861ed2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Ln9AkXsHQAe"
    },
    {
      "id": "custom_6837ed74-27de-42ab-a18d-113b563a0511",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f14c2-c557-7637-94f5-7585e2e5fcf6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-c557-7637-94f5-7585e2e5fcf6",
        "storage_key": "property/5764347288616960/019f14c2-c557-7637-94f5-7585e2e5fcf6.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Westwood Terrace | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/2BL6S4rk4B4"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-74a9-7348-bb9b-a7bc3a0d813d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "westwood-terrace",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960"
    },
    {
      "lead_collector_id": "0198aa46-750a-7179-b11f-47feb43b0de6",
      "lead_source": "FACEBOOK_ADS",
      "name": "westwood-terrace",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960"
    },
    {
      "lead_collector_id": "0198aa46-756c-70b4-99f3-7f34932154f5",
      "lead_source": "LANDING_PAGE",
      "name": "westwood-terrace",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-san-antonio-tx",
      "search_query": "One Bedroom Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Westwood Terrace offers modern living in the vibrant Far West Side. Enjoy a pet-friendly community with easy access to top schools and exciting local attractions.",
      "page_copy": "Located just sixteen miles west of downtown, Westwood Terrace features one bedroom apartments for rent in San Antonio TX, perfect for those seeking a blend of urban convenience and suburban tranquility. Our community is pet-friendly and situated near top educational institutions like Northwest Vista College, making it ideal for students and families alike. Residents enjoy proximity to the Lackland Air Force Base, making it a convenient choice for military families. Explore the nearby Government Canyon State Natural Area for outdoor adventures or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Each apartment features high-speed internet access, washer/dryer hookups, smoke-free living, granite countertops, stainless steel appliances, and a microwave, ensuring a comfortable and modern lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | One Bedroom Apartments For Rent In San Antonio TX",
      "seo_description": "Explore Westwood Terrace's one bedroom apartments for rent in San Antonio TX. Enjoy modern amenities and a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "spacious-two-bedrooms-apartments-for-rent-san-antonio-tx",
      "search_query": "Two Bedrooms Apartments For Rent In San Antonio TX",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedrooms Apartments For Rent In San Antonio TX",
      "h2_subtitle": "Experience the comfort of Westwood Terrace's two-bedroom apartments. Enjoy a pet-friendly environment with access to top schools and vibrant local attractions.",
      "page_copy": "Westwood Terrace offers two bedrooms apartments for rent in San Antonio TX, located in the thriving Far West Side, just sixteen miles from downtown. Our community is perfect for families and professionals seeking a pet-friendly environment with modern amenities. With top schools like Northwest Vista College nearby, it's an ideal location for students and educators. Military families will appreciate the close proximity to Lackland Air Force Base. Residents can explore the Government Canyon State Natural Area for outdoor activities or enjoy local attractions such as the National Shooting Complex and SeaWorld San Antonio. Each apartment features high-speed internet access, washer/dryer hookups, smoke-free living, granite countertops, stainless steel appliances, and a microwave, providing a comfortable and contemporary living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Two Bedrooms Apartments For Rent In San Antonio TX",
      "seo_description": "Discover Westwood Terrace's two bedrooms apartments for rent in San Antonio TX. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers a refreshing pool and modern amenities. Enjoy a pet-friendly community with easy access to top schools and local attractions.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Westwood Terrace, where you can find apartments for rent near me with pool access. Located in the rapidly growing Far West Side of San Antonio, our community is just sixteen miles from downtown, offering a serene escape from the city's hustle and bustle. Residents enjoy a pet-friendly environment with access to top educational institutions like Northwest Vista College, making it ideal for students and families. The nearby Lackland Air Force Base provides convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features a pool, fitness center, clubhouse, EV charging, and controlled access, ensuring a modern and enjoyable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore Westwood Terrace's apartments for rent near me with pool access. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace features a state-of-the-art fitness center and modern amenities. Enjoy a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Explore Westwood Terrace, where you can find apartments for rent near me with fitness center access, offering a perfect balance of convenience and lifestyle. Situated in the thriving Far West Side of San Antonio, our community is just sixteen miles from downtown, providing a peaceful retreat from urban life. Residents benefit from a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base adds convenience for military families. Enjoy outdoor adventures at Government Canyon State Natural Area or visit exciting local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features a fitness center, pool, clubhouse, EV charging, and controlled access, ensuring a modern and active living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find Westwood Terrace's apartments for rent near me with fitness center access. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-clubhouse",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Clubhouse at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers a welcoming clubhouse and modern amenities. Enjoy a pet-friendly community with access to top schools and vibrant local attractions.",
      "page_copy": "Discover the inviting community of Westwood Terrace, where you can find apartments for rent near me with clubhouse access. Located in the rapidly expanding Far West Side of San Antonio, our community is just sixteen miles from downtown, providing a tranquil escape from city life. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an ideal choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Embrace the outdoors at Government Canyon State Natural Area or explore local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features a clubhouse, pool, fitness center, EV charging, and controlled access, ensuring a modern and engaging living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Find Westwood Terrace's apartments for rent near me with clubhouse access. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-ev-charging-westwood-terrace",
      "search_query": "Apartments For Rent Near Me with EV Charging",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with EV Charging at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient EV charging and modern amenities. Enjoy a pet-friendly community with access to top schools and exciting local attractions.",
      "page_copy": "Discover the eco-friendly living at Westwood Terrace, where you can find apartments for rent near me with EV charging. Located in the vibrant Far West Side of San Antonio, our community is just sixteen miles from downtown, offering a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it a great choice for students and families. The nearby Lackland Air Force Base provides added convenience for military families. Explore the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features EV charging, a pool, fitness center, clubhouse, and controlled access, ensuring a sustainable and comfortable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with EV Charging",
      "seo_description": "Explore Westwood Terrace's apartments for rent near me with EV charging. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-high-speed-internet",
      "search_query": "Apartments For Rent Near Me with High-Speed Internet Access",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with High-Speed Internet Access at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers seamless connectivity with high-speed internet access and modern amenities. Enjoy a pet-friendly community with access to top schools and attractions.",
      "page_copy": "Stay connected at Westwood Terrace, where you can find apartments for rent near me with high-speed internet access. Located in the dynamic Far West Side of San Antonio, our community is just sixteen miles from downtown, offering a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an ideal choice for students and families. The nearby Lackland Air Force Base provides added convenience for military families. Explore the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features high-speed internet access, washer/dryer hookups, smoke-free living, granite countertops, stainless steel appliances, and a microwave, ensuring a connected and comfortable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with High-Speed Internet Access",
      "seo_description": "Discover Westwood Terrace's apartments for rent near me with high-speed internet access. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-washer-dryer",
      "search_query": "Apartments For Rent with Washer/Dryer Hookup",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent with Washer/Dryer Hookup at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient washer/dryer hookups and modern amenities. Enjoy a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Experience the convenience of Westwood Terrace, where you can find apartments with washer/dryer hookup. Situated in the rapidly growing Far West Side of San Antonio, our community is just sixteen miles from downtown, providing a tranquil escape with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Embrace the outdoors at Government Canyon State Natural Area or explore local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features washer/dryer hookups, high-speed internet access, smoke-free living, granite countertops, stainless steel appliances, and a microwave, ensuring a comfortable and modern living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent with Washer/Dryer Hookup",
      "seo_description": "Find Westwood Terrace's apartments for rent with washer/dryer hookup. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-smoke-free",
      "search_query": "Smoke-Free Apartments For Rent Near Me ",
      "category": "Amenity",
      "h1_title": "Explore Smoke-Free Apartments For Rent Near Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers a smoke-free environment and modern amenities. Enjoy a pet-friendly community with access to top schools and vibrant local attractions.",
      "page_copy": "Discover the healthy living environment at Westwood Terrace, where you can find apartments for rent near me with smoke-free options. Located in the rapidly expanding Far West Side of San Antonio, our community is just sixteen miles from downtown, offering a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly atmosphere and proximity to top educational institutions like Northwest Vista College, making it an ideal choice for students and families. The nearby Lackland Air Force Base provides added convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features smoke-free living, high-speed internet access, washer/dryer hookups, granite countertops, stainless steel appliances, and a microwave, ensuring a clean and comfortable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Smoke-Free Apartments For Rent ",
      "seo_description": "Discover Westwood Terrace's smoke-free apartments for rent. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Granite Countertops at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers stylish granite countertops and modern amenities. Enjoy a pet-friendly community with access to top schools and exciting local attractions.",
      "page_copy": "Experience the elegance of Westwood Terrace, where you can find apartments for rent near me with granite countertops. Located in the thriving Far West Side of San Antonio, our community is just sixteen miles from downtown, providing a serene escape with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Explore the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features granite countertops, high-speed internet access, washer/dryer hookups, smoke-free living, stainless steel appliances, and a microwave, ensuring a stylish and comfortable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Discover Westwood Terrace's apartments for rent near me with granite countertops. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Stainless Steel Appliances at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers modern stainless steel appliances and stylish amenities. Enjoy a pet-friendly community with access to top schools and vibrant local attractions.",
      "page_copy": "Explore the contemporary living at Westwood Terrace, where you can find apartments for rent near me with stainless steel appliances. Situated in the rapidly growing Far West Side of San Antonio, our community is just sixteen miles from downtown, offering a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an ideal choice for students and families. The nearby Lackland Air Force Base provides added convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features stainless steel appliances, high-speed internet access, washer/dryer hookups, smoke-free living, granite countertops, and a microwave, ensuring a sleek and comfortable living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Find Westwood Terrace's apartments for rent near me with stainless steel appliances. Enjoy modern amenities in a pet-friendly community near top schools and attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-san-antonio-tx-near-christus-hospital",
      "search_query": "Apartments For Rent In San Antonio TX Near Westover Hills",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In San Antonio TX Near Westover Hills",
      "h2_subtitle": "Westwood Terrace offers convenient living near Westover Hills. Enjoy modern amenities in a pet-friendly community with easy access to local attractions.",
      "page_copy": "Discover the ideal living space at Westwood Terrace, where you can find apartments for rent in San Antonio TX near Westover Hills. Located in the rapidly expanding Far West Side, our community is just sixteen miles from downtown, providing a serene escape with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Explore the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near Westover Hills",
      "seo_description": "Discover Westwood Terrace's apartments for rent in San Antonio TX near Westover Hills. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-san-antonio-tx-near-conviva",
      "search_query": "Apartments For Rent In San Antonio TX Near Conviva Care Center",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In San Antonio TX Near Conviva Care Center at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near Conviva Care Center. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Discover the ideal living environment at Westwood Terrace, where you can find apartments for rent in San Antonio TX near Conviva Care Center. Located in the vibrant Far West Side, our community is just sixteen miles from downtown, providing a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly atmosphere and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near Conviva Care Center",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near Conviva Care Center. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-san-antonio-college",
      "search_query": "Apartments For Rent In San Antonio TX Near San Antonio College",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In San Antonio TX Near San Antonio College at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near San Antonio College. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Discover the ideal living environment at Westwood Terrace, where you can find apartments for rent in San Antonio TX near San Antonio College. Located in the vibrant Far West Side, our community is just sixteen miles from downtown, providing a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly atmosphere and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near San Antonio College",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near San Antonio College. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-san-antonio-tx-near-st-marys",
      "search_query": "Apartments For Rent In San Antonio TX Near St. Mary's University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near St. Mary's University at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near St. Mary's University. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Explore the perfect living space at Westwood Terrace, where you can find apartments for rent in San Antonio TX near St. Mary's University. Located in the rapidly expanding Far West Side, our community is just sixteen miles from downtown, providing a serene escape with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions like Northwest Vista College, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near St. Mary's University",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near St. Mary's University. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-northwest-vista",
      "search_query": "Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In San Antonio TX Near Northwest Vista College at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near Northwest Vista College. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Discover the ideal living environment at Westwood Terrace, where you can find apartments for rent in San Antonio TX near Northwest Vista College. Located in the vibrant Far West Side, our community is just sixteen miles from downtown, providing a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly atmosphere and proximity to top educational institutions, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near Northwest Vista College",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near Northwest Vista College. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-our-lady-university",
      "search_query": "Apartments For Rent In San Antonio TX Near Our Lady of the Lake University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In San Antonio TX Near Our Lady of the Lake University at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near Our Lady of the Lake University. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Explore the perfect living space at Westwood Terrace, where you can find apartments for rent in San Antonio TX near Our Lady of the Lake University. Located in the rapidly expanding Far West Side, our community is just sixteen miles from downtown, providing a serene escape with modern conveniences. Residents enjoy a pet-friendly environment and proximity to top educational institutions, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near Our Lady of the Lake University",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near Our Lady of the Lake University. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5764347288616960",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-san-antonio-tx-koehler-house",
      "search_query": "Apartments For Rent In San Antonio TX Near The Koehler House",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In San Antonio TX Near The Koehler House at Westwood Terrace",
      "h2_subtitle": "Westwood Terrace offers convenient living near The Koehler House. Enjoy modern amenities in a pet-friendly community with access to top schools and local attractions.",
      "page_copy": "Discover the ideal living environment at Westwood Terrace, where you can find apartments for rent in San Antonio TX near The Koehler House. Located in the vibrant Far West Side, our community is just sixteen miles from downtown, providing a peaceful retreat with modern conveniences. Residents enjoy a pet-friendly atmosphere and proximity to top educational institutions, making it an excellent choice for students and families. The nearby Lackland Air Force Base offers convenience for military families. Enjoy the great outdoors at Government Canyon State Natural Area or visit local attractions such as the National Shooting Complex and SeaWorld San Antonio. Our community features controlled access, EV charging, a clubhouse, fitness center, and pool, ensuring a comfortable and connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019f6c14-2afa-71bd-bf81-a4b86dcacee2",
        "storage_key": "property/5764347288616960/019f6c14-2afa-71bd-bf81-a4b86dcacee2.webp",
        "width": 1920,
        "height": 1438
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
      "blank_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at a multifamily property",
        "public_id": "019f6c14-3615-7397-83cc-2c7d0f296e79",
        "storage_key": "property/5764347288616960/019f6c14-3615-7397-83cc-2c7d0f296e79.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Westwood Terrace | Apartments For Rent In San Antonio TX Near The Koehler House",
      "seo_description": "Find Westwood Terrace's apartments for rent in San Antonio TX near The Koehler House. Enjoy modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2289"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505044123"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a6d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a6d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4981190"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5VQ64KL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8775177759"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "4098468bce411f13"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9e400po9"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ba9fd233-1e6d-4b31-9d69-b33e000593cb"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-470-3153"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ijlxa2gwS0JDbU1Kclh2Ym5lbnZPclE9PSIsInZhbHVlIjoib2U0SjVvVHBoWklMT3RhTGpwL3pzUT09IiwibWFjIjoiMWMwN2NiN2UwMTJjYmM2NjYxYWU4MTdlYTdhMzY3YTM0YThjYmYyYThiYzYwZjBhM2QwMjBmMTc0ZTllYjY5NSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2289",
  "custom_repli_id": "2505044123",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a6d\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a6d\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4981190",
  "custom_google_gtm_id": "GTM-5VQ64KL",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8775177759",
  "custom_knock_community_id": "4098468bce411f13",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9e400po9",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ba9fd233-1e6d-4b31-9d69-b33e000593cb",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "361-470-3153",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ijlxa2gwS0JDbU1Kclh2Ym5lbnZPclE9PSIsInZhbHVlIjoib2U0SjVvVHBoWklMT3RhTGpwL3pzUT09IiwibWFjIjoiMWMwN2NiN2UwMTJjYmM2NjYxYWU4MTdlYTdhMzY3YTM0YThjYmYyYThiYzYwZjBhM2QwMjBmMTc0ZTllYjY5NSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "a1c1bb00-2807-4602-bc44-70114b5c503c",
  "custom_audioeye_site_hash": "2bba9648ef9b1f4211c07206fe35b53c"
};

export const generatedAt = '2026-11-03T20:27:32.378Z';
